import './accordion.scss';

export default () => {
	// ACCORDION
	let headers = document.querySelectorAll( '.accordion__title' );

	headers.forEach( ( header ) => {
		header.addEventListener( 'click', () => {
			const content = header.nextElementSibling;

			if ( content.style.maxHeight && content.style.maxHeight !== '0px' ) {
				content.style.maxHeight = 0;
				header.classList.remove( 'active' );
			} else {
				document.querySelectorAll( '.accordion__content' ).forEach( ( item, i ) => {
					item.style.maxHeight = 0;
					headers[ i ].classList.remove( 'active' );
				} );
				content.style.maxHeight = `${content.scrollHeight}px`;
				header.classList.add( 'active' );
			}
		} );
	} );
};
